import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { IEquipment, TransferStatus } from '@services/registrations/registrations.models';
import { RegistrationsService } from '@services/registrations';

@Component({
	selector: 'app-view-transfer-details',
	templateUrl: './view-transfer-details.component.html',
	styleUrls: ['./view-transfer-details.component.scss']
})
export class ViewTransferDetailsComponent implements OnInit {

	public request;
	public requestDetails = [];
	public bikeDetails = [];
	public userDetails = [];
	public statusDetails = [];

	constructor(
		@Inject(MAT_DIALOG_DATA) public dialogData,
		private dialogRef: MatDialogRef<ViewTransferDetailsComponent>,
		public registrationsService: RegistrationsService
	) { }

	close(): void {
		this.dialogRef.close();
	}

	ngOnInit(): void {
		this.request = this.dialogData['request'];
		console.log('ViewTransferDetailsComponent - ngOnInit: ', this.request);

		this.loadRequestDetails();
		this.loadUserDetails();
		this.loadStatusDetails();

		this.registrationsService.bikesById(
			this.request['bikeId']
		).subscribe((res: IEquipment) => {
			this.loadBikeDetails(res);
		});
	}

	loadRequestDetails(): void {
		this.requestDetails = [
			{ label: 'ID',           value: this.request['id'] },
			{ label: 'Created At',   value: this.request['createdAt'] },
			{ label: 'Initiated By', value: 'ADMIN (' + this.request['adminUserIdentifier'] + ')' }
		];
	}

	loadBikeDetails(bike: IEquipment): void {
		this.bikeDetails = [
			{ label: 'Bike ID',       value: this.request['bikeId'], view: 'bikeId'},
			{ label: 'Serial Number', value: bike['serialNumber'] },
			{ label: 'Item Number',   value: bike['itemNumber'] }
		];
	}

	loadUserDetails(): void {
		this.userDetails = [
			{ label: 'Source User ID (internal)', value: this.request['sourceUserIdentifier'], view: 'sourceUserIdentifier'},
			{ label: 'Source User Email',         value: '' },
			{ label: 'New Owner ID (internal)',   value: this.request['destinationUserIdentifier'], view: 'destinationUserIdentifier' },
			{ label: 'New Owner Email',           value: this.request['destinationEmail'] }
		];
	}

	loadStatusDetails(): void {
		this.statusDetails = [
			{ label: 'Status',    value: this.request['status'] }
		];

		switch (this.request['status']) {
			case TransferStatus.open:
				this.statusDetails.push({ label: 'Notifications Sent', value: `${this.request['notificationsSent']} of ${this.request['maxNotifications']} sent` });
				this.statusDetails.push({ label: 'Next Notification', value: this.request['nextNotificationSendsAt'] });
				this.statusDetails.push({ label: 'Autocloses At', value: this.request['autoclosesAt'] });
			break;

			case TransferStatus.accepted:
				this.statusDetails.push({ label: 'Closed By', value: this.request['autoclosed'] ? 'AUTO' : 'USER' });
				this.statusDetails.push({ label: 'Closed At', value: this.request['closedAt'] });
				this.statusDetails.push({ label: 'Notifications Sent', value: `${this.request['notificationsSent']} of ${this.request['maxNotifications']} sent` });
				break;

			case TransferStatus.denied:
				break;
		}
	}
}
